import { URLService } from '../url.service';
import { DealerShareBuilder } from './dealer.share';
export class PromotionShareDataBuilder extends DealerShareBuilder {
  constructor ({ dealerInfo, shareInfo, promotionInfo, shareLink }) {
    super({ dealerInfo, shareInfo });
    this.promotionInfo = promotionInfo;
    this.shareLink = shareLink;
  }
  buildShareData () {
    const { remainDays, openType, actId, title } = this.promotionInfo;
    const shareInfo = this.shareInfo
    const pvAreaId = this.getPvareaId();
    const desc = `距报名截止时间还有${remainDays}天`;
    let shareUrl = this.buildPromotionShareUrl(openType, actId, this.shareLink, pvAreaId);
    return { isNative: true, platform: 'all', hideMiniProgram: true, title: title, desc, icon: shareInfo && shareInfo.dealerImage, shareUrl };
  }
  /**
  * 构建促销详情分享url
  * @param {*} openType 
  * @param {*} actId 
  * @returns 
  */
  buildPromotionShareUrl (openType, actId, shareLink, pvAreaId) {
    let urlService = new URLService(shareLink);
    urlService.queryParams
      .remove('pvareaid')
      .remove('openType')
      .remove('actId')
      .append('pvareaid', pvAreaId)
      .append('openType', openType)
      .append('actId', actId);
    let shareUrl = urlService.build();
    return shareUrl;
  }
}